import { useEffect } from 'react';
import { useSetState } from 'react-use';

export function useDimensions(width: number, itemSize: any, small: boolean) {
  const [state, patchState] = useSetState({
    totalWidth: 0,
    columnCount: 0,
    columnWidth: 0,
    rowHeight: 0,
  });

  useEffect(() => {
    const totalWidth = width;
    let rowHeight = small ? 130 : 230;
    const divider = small ? 130 : 200;
    let columnCount = Math.floor(totalWidth / divider);
    let columnWidth = totalWidth / columnCount - 14;

    if (itemSize) {
      const { width, height } = itemSize;
      columnWidth = width;
      rowHeight = height;
      columnCount = Math.floor(totalWidth / width);
    }

    patchState({
      totalWidth,
      columnCount,
      columnWidth,
      rowHeight,
    });
  }, [width]);

  return state;
}
